
export { default as SaleCertificate } from './items/saleCertificate.jsx';
export {
  BenefitsPurchaseTickets,
} from './items/BenefitsPurchaseTickets/index.jsx';
export { AttendanceRules } from './items/AttendanceRules';
export { GitaFestival26 } from './items/GitaFestival26';
export {
  HearingAndVisionImpairmentsV2,
} from './items/HearingAndVisionImpairmentsV2';


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/index.jsx